import firebase from "firebase";
var firebaseConfig = {
  apiKey: "AIzaSyBLsnuAsXkAi1XWvEVX3nTujswvEWVUQRI",
  authDomain: "linked-clone17.firebaseapp.com",
  projectId: "linked-clone17",
  storageBucket: "linked-clone17.appspot.com",
  messagingSenderId: "31092226392",
  appId: "1:31092226392:web:ff2b2f020a0414a8ae4d2d"
};
  const firebaseApp = firebase.initializeApp(firebaseConfig);
  const db = firebaseApp.firestore();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();
  const storage = firebase.storage();

  export { auth, provider, storage};
  export default db;